import { resolveSelectors } from '../resolver.mjs';
import { versionedComponents } from './components.mjs';
import { versionedPages } from './pages.mjs';

const Pages = resolveSelectors(versionedPages);
const Components = resolveSelectors(versionedComponents);
const selectors = { pages: Pages, components: Components };

export { Components, Pages, resolveSelectors, selectors, versionedComponents, versionedPages };
//# sourceMappingURL=index.mjs.map
